import { render, staticRenderFns } from "./CartShareModal.vue?vue&type=template&id=35220ef6&"
import script from "./CartShareModal.vue?vue&type=script&lang=js&"
export * from "./CartShareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports